export const dayOrderConstants = {
    GETDETAIL_REQUEST: 'DAYORDERS_GETDETAIL_REQUEST',
    GETDETAIL_SUCCESS: 'DAYORDERS_GETDETAIL_SUCCESS',
    GETDETAIL_FAILURE: 'DAYORDERS_GETDETAIL_FAILURE',

    UPDATE_REQUEST: 'DAYORDERS_UPDATE_REQUEST',
    UPDATE_SUCCESS: 'DAYORDERS_UPDATE_SUCCESS',
    UPDATE_FAILURE: 'DAYORDERS_UPDATE_FAILURE',
};



// WEBPACK FOOTER //
// ./src/_constants/dayOrder.constants.js